<div class="db-skeleton-loader" role="status" aria-live="polite">
  <span class="visually-hidden">{{ label }}</span>

  <div class="db-skeleton-loader__row" aria-hidden="true" *ngFor="let row of rowRange">
    @if (showLeadingIcon) {
    <span class="db-skeleton-circle db-skeleton-loader__icon"></span>
    }

    <div class="db-skeleton-loader__columns">
      <div class="db-skeleton-loader__column" *ngFor="let column of columnRange">
        <span class="db-skeleton-line db-skeleton-loader__bar"></span>
        @if (linesPerColumn === 2) {
        <span class="db-skeleton-line db-skeleton-loader__bar db-skeleton-loader__bar--sub"></span>
        }
      </div>
    </div>
  </div>
</div>
